module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic_1.cc4dbcc8.woff";